<template>
  <div
    style="
      min-height: 100% !important;
      width: 100% !important;
      display: flex;
      justify-content: center;
    "
  >
    <div
      v-if="showLoader"
      class="d-flex justify-content-center align-items-center"
      style="height: 100%; flex-direction: column; margin: auto 0"
    >
      <p class="logging-in">{{ loadingText }}</p>
      <b-spinner class="loading-spinner" label="Text Centered" />
    </div>
    <div v-show="showOffer" id="offer" class="animated">
      <div id="offer-template" style="min-height: 100% !important; width: 100% !important" />
    </div>
    <div id="checkout" />
    <div v-show="showOfferLicenseForm">
      <div id="license-form" />
    </div>
    <div id="l-form-response" v-show="showOfferLicenseFormResponse">
      <div id="license-form-response"></div>
    </div>
    <div id="form-response" v-show="showOfferFormResponse">
      <form-response @closeResponse="formResponseClose" :statusSuccess="formSuccessStatus" />
    </div>
  </div>
</template>
<script>
// "@vue-stripe/vue-stripe": "^4.4.2", INSTALL STRIPE!!!

// eslint-disable-next-line no-unused-vars
import Vue from 'vue';
import axios from 'axios';
import { TonosOffer, LicenseRequestForm } from '@gjirafatech/template-butmania';
import store from '../store/index';
import Offer from '../models/offer';
import LicenseFormResponse from './LicenseFormResponse.vue';
import LicenseRequestFormModel from '../models/license-form/licenseRequestFormModel';
// import Checkout from '../components/Checkout.vue';
import FormResponse from './FormResponse.vue';
import handlePostMessage from '../mixins/handlePostMessage';

import Api from '../utils/api';
import configs from '../utils/configs';

export default {
  name: 'Offer',
  components: {
    // eslint-disable-next-line vue/no-unused-components
    // 'lazy-checkout': () => import('../components/Checkout.vue'),
    // eslint-disable-next-line vue/no-unused-components
    TonosOffer,
    FormResponse,
  },
  mixins: [handlePostMessage],
  data() {
    return {
      checkoutComponent: null,
      licenseFormComponent: null,
      licenseFormResponseComponent: null,
      showOfferLicenseForm: false,
      showOfferLicenseFormResponse: false,
      showOfferFormResponse: false,
      formSuccessStatus: true,
      offerHeightInterval: null,
      tonosOfferComponent: null,
    };
  },
  computed: {
    aId() {
      return store.getters.aId;
    },
    cId() {
      return store.getters.cId;
    },
    tId() {
      return store.getters.tId;
    },
    oI() {
      return store.getters.oI;
    },
    offer() {
      return store.getters.offer;
    },
    isLoggedIn() {
      return store.getters.isLoggedIn;
    },
    clientToken() {
      return store.getters.clientToken;
    },
    selectedPap() {
      return store.getters.selectedPap;
    },
    licenseForm() {
      return store.getters.licenseForm;
    },
    returnUrl() {
      return store.getters.returnUrl;
    },
    returnErrorUrl() {
      return store.getters.returnErrorUrl;
    },
    showOffer: {
      get() {
        return store.getters.showOffer;
      },
      set(value) {
        store.commit('setShowOffer', value);
      },
    },
    showLoader: {
      get() {
        return store.getters.showLoader;
      },
      set(value) {
        store.commit('setShowLoader', value);
      },
    },
    loadingText: {
      get() {
        return store.getters.loadingText;
      },
      set(value) {
        store.commit('setLoadingText', value);
      },
    },
    user: {
      get() {
        return store.getters.user;
      },
      set(value) {
        store.commit('setUser', value);
      },
    },
  },
  beforeCreate() {
    const params = new URLSearchParams(window.location.search.substring(1));
    store.commit('setAId', params.get('aId'));
    store.commit('setCId', params.get('cId'));
    store.commit('setTId', params.get('tId'));
    store.commit('setClientToken', params.get('token'));
    store.commit('setReturnUrl', decodeURIComponent(params.get('returnUrl')));
    store.commit('setBiskoId', params.get('biskoId'));
    store.commit('setPageId', params.get('pageId'));
    store.commit('setLangId', params.get('langId'));

    store.commit('setExperimentId', params.get('exid'));

    store.commit('setCpt', params.get('cpt'));
    store.commit('setCft', params.get('cft'));
    if (params.get('selectedPap')) {
      store.commit(
        'setSelectedPap',
        JSON.parse(decodeURIComponent(params.get('selectedPap'))).papDetails,
      );
    }
    if (params.get('user')) {
      // console.log('USERRR', JSON.parse(decodeURIComponent(params.get('user'))));
      store.commit('setUser', JSON.parse(decodeURIComponent(params.get('user'))));
    }
  },
  created() {
    // this.askIfTokenHasBeenChanged();
    // this.listenMessages().then(() => {
    this.getOffer()
      .then(this.setOffer.bind(this))
      .catch(this.offerError.bind(this));
    // });
  },
  methods: {
    LazyCheckout: () => import('../components/Checkout.vue'),
    getOffer() {
      // eslint-disable-next-line new-cap
      return Api.get(`offer?aid=${this.aId}&cid=${this.cId}&tid=${this.tId}`);
    },
    setOffer(response) {
      const res = JSON.parse(response.response);
      store.commit('setOffer', new Offer(res.data, this.returnUrl));
      const off = document.getElementById('offer');
      if (!this.offer.paps.length && !this.offer.licenses.length && !this.offer.forms.length) {
        this.offerError('OFFER CONTAINS NOTHING!');
        return;
      }
      this.createOfferTemplate();
      // console.log('offerTemplateComponent', offerTemplateComponent);

      // CHECK IF SELECTED PAP HAS ACCESS, DO NOT SHOW CHECKOUT
      // console.log('this.selectedPap', this.selectedPap);
      if (this.selectedPap && this.checkIfCheckoutShouldAutoShow() && this.offer.hasCheckout) {
        // console.log('SHOW AUTO CHECKOUT!!!!', this.selectedPap)
        if (this.offer.type === configs.OFFER_TYPE.MODAL) {
          this.showOffer = false;
          this.showLoader = true;
          this.loadingText = 'Loading Checkout...';
          this.openCheckoutIframeModal(this.selectedPap);
          // this.autoOpenCheckout();
        }
        if (this.offer.type === configs.OFFER_TYPE.INLINE) {
          off.classList.remove('animated');
          this.openCheckoutIframe(this.selectedPap);
        }
      }
      if (this.offer.type === configs.OFFER_TYPE.INLINE) {
        this.showOffer = true;
      }
      if (this.offer.hasCheckout && this.isLoggedIn) this.mountCheckout();

      // console.log('OFFER LICENSES', this.offer.licenses);
      if (this.offer.licenses.length > 0) this.mountLicenseForm();
      this.resizeIframe();
      this.offerHeightInterval = setInterval(() => {
        this.resizeIframe();
      }, 100);
      setTimeout(() => {
        off.classList.remove('animated');
      }, 1000);
    },
    createOfferTemplate() {
      const tonosOffer = Vue.extend(TonosOffer);
      // eslint-disable-next-line new-cap
      this.tonosOfferComponent = new tonosOffer({
        propsData: {
          productAccessProviders: this.offer.paps,
          offerTemplate: this.offer.template,
          offerLicenses: this.offer.licenses,
          offerForms: this.offer.forms,
          isLandingOffer: this.offer.getIsLandingOffer(),
          offerTemplateCard: this.offer.getTemplateCard(),
          offerTemplateCardItems: this.offer.getTemplateCardItems(),
          isLoggedIn: this.isLoggedIn,
        },
      });
      this.tonosOfferComponent.$on('checkout', this.checkout);
      this.tonosOfferComponent.$on('register', this.register);
      this.tonosOfferComponent.$on('submitForm', this.submitForm);
      this.tonosOfferComponent.$on('license', this.licenseRequestForm);
      this.tonosOfferComponent.$on('close', this.closeIframe);
      this.tonosOfferComponent.$on('offerMounted', this.offerLoaded);
      this.tonosOfferComponent.$on('loginUser', this.loginUser);
      this.tonosOfferComponent.$on('redirect', this.redirect);

      this.tonosOfferComponent.$mount('#offer-template');
    },
    checkIfCheckoutShouldAutoShow() {
      return !!this.selectedPap && this.offer.paps.find((x) => x.papId === this.selectedPap.papId)
        ? !this.offer.paps.find((x) => x.papId === this.selectedPap.papId).hasAccess
        : false;
    },
    async mountCheckout() {
      if (this.offer.type === configs.OFFER_TYPE.INLINE) return;
      const { default: lazyCheckout } = await this.LazyCheckout();
      // console.error('this.LazyCheckout', lazyCheckout)
      const Checkout = Vue.extend(lazyCheckout);
      // eslint-disable-next-line new-cap
      // console.error('dasdbajdvhjabdhjadas', Checkout)
      if (this.checkIfCheckoutShouldAutoShow()) {
        this.showOffer = false;
      }
      this.checkoutComponent = new Checkout({
        propsData: {
          autoOpenProp: this.checkIfCheckoutShouldAutoShow(),
          papIdProp: this.selectedPap ? this.selectedPap.papId : null,
        },
      });

      // console.error('this.checkoutComponentddddddddddd', this.checkoutComponent)

      if (this.selectedPap) {
        store.commit('setSelectedPap', null);
      }
      this.checkoutComponent.$mount('#checkout');
      this.checkoutComponent.$on('close', this.open);
    },
    getLicenseForm(id) {
      // eslint-disable-next-line new-cap
      return Api.get(`license-request-form/${id}`);
    },
    mountLicenseForm() {
      if (this.offer.type === configs.OFFER_TYPE.INLINE) return;
      const licenseForm = Vue.extend(LicenseRequestForm);
      // eslint-disable-next-line new-cap
      this.licenseFormComponent = new licenseForm({
        propsData: {
          licenseRequestForm: {
            name: 'initial',
            publicId: 'initial-form',
            licenseRequestFormInputs: [],
            licenseSettings: {
              currencyId: null,
              currency: null,
              licensePriceTiers: [],
            },
          },
        },
      });

      this.licenseFormComponent.$mount('#license-form');

      this.licenseFormComponent.$on('closeLicenseForm', this.closeForm);
      this.licenseFormComponent.$on('submitRequestForm', this.submitLicenseFormRequest);
      // this.showLoader = false;
      // this.showOfferLicenseForm = true;
    },
    autoOpenCheckout() {
      this.checkout(this.selectedPap);
    },

    offerError(response) {
      console.error('ERROR', response);
      this.closeIframeError();
      // this.closeIframe();
    },
    checkout(papDetails) {
      this.askIfTokenHasBeenChanged();
      let checkoutInterval = null;

      this.listenMessages().then(() => {
        if (this.isLoggedIn) {
          if (this.offer.type === configs.OFFER_TYPE.INLINE) {
            this.showOffer = true;
            this.openCheckoutIframe(papDetails);
          } else {
            try {
              this.showLoader = true;
              this.showOffer = false;
              this.loadingText = 'Loading checkout...';
              if (this.checkoutComponent.isCheckoutReady()) {
                this.showLoader = false;
                this.checkoutComponent.open(papDetails.papId);
              } else {
                checkoutInterval = setInterval(() => {
                  if (this.checkoutComponent.isCheckoutReady()) {
                    this.showLoader = false;
                    this.checkoutComponent.open(papDetails.papId);
                    clearInterval(checkoutInterval);
                  }
                }, 100);
              }
              // this.closeCheckout();
            } catch (error) {
              console.error('CHECKOUTT ERR', error);
              this.checkoutComponent.close();
              return;
            }
            this.openCheckoutIframeModal(papDetails);
          }
          this.planSelected(papDetails);
        } else {
          this.register(papDetails);
        }
      });
    },
    register(papDetails) {
      this.loadingText = 'Logging in...';
      this.showLoader = true;
      this.showOffer = false;
      const msg = {
        name: process.env.VUE_APP_IFRAME_MESSAGE_REGISTER,
        tId: this.tId,
        data: {
          papDetails,
          tId: this.offer.id,
          cId: this.cId,
        },
      };
      window.parent.postMessage(msg, document.referrer);
      setTimeout(() => {
        this.showLoader = false;
        this.showOffer = true;
      }, 25000);
    },
    redirect(data) {
      const msg = {
        name: process.env.VUE_APP_IFRAME_MESSAGE_REDIRECT_TO_SPECIFIED_PAGE,
        cId: this.cId,
        tId: this.tId,
        data: {
          papDetails: data,
          redirectUrl: data.redirectUrl,
        },
      };
      window.parent.postMessage(msg, document.referrer);
    },
    loginUser() {
      this.loadingText = 'Logging in...';
      this.showLoader = true;
      this.showOffer = false;
      const msg = {
        name: process.env.VUE_APP_IFRAME_MESSAGE_LOG_IN_USER,
        cId: this.cId,
        tId: this.tId,
        data: {
          clId: this.clientToken,
          cId: this.cId,
          paps: JSON.stringify(this.offer ? this.offer.paps : []),
          oI: this.oI,
          offerName: this.offer ? this.offer.name : '',
          // eslint-disable-next-line no-nested-ternary
          type: this.offer ? (this.offer.type === 1 ? 'modal' : 'inline') : null,
        },
      };
      window.parent.postMessage(msg, document.referrer);
      setTimeout(() => {
        this.showLoader = false;
        this.showOffer = true;
      }, 1500);
    },
    licenseRequestForm(licenseFormId) {
      if (this.offer.type === configs.OFFER_TYPE.INLINE) {
        this.openLicenseFormIframe(licenseFormId);
      } else {
        this.loadingText = 'Loading...';
        this.showOffer = false;
        this.showLoader = true;
        this.getLicenseForm(licenseFormId)
          .then((response) => {
            const res = JSON.parse(response.response);
            store.commit('setLicenseForm', new LicenseRequestFormModel(res.data));
            this.licenseFormComponent.licenseRequestForm = new LicenseRequestFormModel(res.data);
            this.licenseFormComponent.numberOfMemberships = 1;
            this.showOffer = false;
            this.showLoader = false;
            this.showOfferLicenseForm = true;
          })

          .catch((err) => {
            console.error('license request form error', err);
            this.showOffer = true;
            this.showOfferLicenseForm = false;
            this.showLoader = false;
          });
      }
      this.licenseSelected(licenseFormId);
    },

    submitForm(data) {
      // console.log('NEWSLETTER EMAIL', data);
      axios
        .post(
          `${process.env.VUE_APP_BASE_CLIENT_URL}forms/submit`,
          { fId: data.id, e: data.email, cc: data.consentFields },
          {
            headers: {
              AppId: this.aId,
              LangId: 1,
            },
          },
        )
        .then((response) => {
          // console.log('submit response', response);
          this.showOffer = false;
          this.formSuccessStatus = true;
          this.showOfferFormResponse = true;
          const msg = {
            name: process.env.VUE_APP_IFRAME_MESSAGE_C_FORM_TOKEN,
            cId: this.cId,
            tId: this.tId,
            data: {
              cft: response.data.data,
            },
          };
          window.parent.postMessage(msg, document.referrer);
        })
        .catch((error) => {
          this.showOffer = false;
          this.formSuccessStatus = false;
          this.showOfferFormResponse = true;
          console.error('error submitting', error.response.data);
        });
    },
    formResponseClose() {
      if (this.formSuccessStatus) {
        this.closeIframe();
      } else {
        this.showOffer = true;
        this.showOfferFormResponse = false;
        this.formSuccessStatus = true;
      }
    },
    submitLicenseFormRequest(submitedForm) {
      this.askIfTokenHasBeenChanged();
      this.listenMessages().then(() => {
        axios
          .post(`${process.env.VUE_APP_BASE_CLIENT_URL}license-request`, submitedForm, {
            headers: {
              Authorization: `Bearer ${this.clientToken}`,
              AppId: this.aId,
              LangId: 1,
            },
          })
          .then(() => {
            // console.log('submit response', response);
            const licenseFormResponse = Vue.extend(LicenseFormResponse);
            this.showOfferLicenseForm = false;
            this.showOffer = false;
            this.showOfferLicenseFormResponse = true;

            if (!this.licenseFormResponseComponent) {
              // eslint-disable-next-line new-cap
              this.licenseFormResponseComponent = new licenseFormResponse();
              this.licenseFormResponseComponent.$mount('#license-form-response');
              this.licenseFormResponseComponent.$on('closeResponse', this.closeLicenseFormResponse);
            }
            const msg = {
              name: process.env.VUE_APP_IFRAME_MESSAGE_SUBMITTED_LICENSE_REQUEST_FORM,
              cId: this.cId,
              tId: this.tId,
              data: {
                name: this.licenseForm.name,
                id: this.licenseForm.publicId,
                numberOfMemberships: submitedForm.numberOfMemberships,
                price: submitedForm.price,
                currency: this.licenseForm.licenseSettings.currency,
              },
            };
            window.parent.postMessage(msg, document.referrer);
          })

          .catch((err) => {
            console.error('error submitting', err);
            this.showOffer = true;
            this.showOfferLicenseForm = false;
            this.showLoader = false;
          });
      });
    },
    closeForm() {
      this.showOfferLicenseForm = false;
      this.showOffer = true;
    },
    closeLicenseFormResponse() {
      this.showOfferLicenseFormResponse = false;
      this.showOffer = true;
    },
    openCheckoutIframe(papDetails) {
      const msg = {
        name: process.env.VUE_APP_IFRAME_MESSAGE_OPEN_CHECKOUT_IFRAME,
        cId: this.cId,
        tId: this.tId,
        data: {
          papDetails,
          oI: this.oI,
          offerName: this.offer ? this.offer.name : '',
          cId: this.cId,
          tId: this.offer.id,
        },
      };
      window.parent.postMessage(msg, document.referrer);
    },
    openLicenseFormIframe(licenseFormId) {
      const msg = {
        name: process.env.VUE_APP_IFRAME_MESSAGE_OPEN_LICENSE_FORM_IFRAME,
        cId: this.cId,
        tId: this.tId,
        data: {
          licenseFormId,
        },
      };
      window.parent.postMessage(msg, document.referrer);
    },
    openCheckoutIframeModal(papDetails) {
      const msg = {
        name: process.env.VUE_APP_IFRAME_MESSAGE_OPEN_CHECKOUT,
        cId: this.cId,
        tId: this.tId,
        data: {
          papDetails,
          oI: this.oI,
          offerName: this.offer ? this.offer.name : '',
          cId: this.cId,
          tId: this.offer.id,
        },
      };
      window.parent.postMessage(msg, document.referrer);
    },
    planSelected(papDetails) {
      const msg = {
        name: process.env.VUE_APP_IFRAME_MESSAGE_PLAN_SELECTED,
        cId: this.cId,
        tId: this.tId,
        data: {
          papDetails,
          oI: this.oI,
          offerName: this.offer ? this.offer.name : '',
          cId: this.cId,
          tId: this.offer.id,
        },
      };
      window.parent.postMessage(msg, document.referrer);
    },
    licenseSelected(id) {
      const msg = {
        name: process.env.VUE_APP_IFRAME_MESSAGE_LICENSE_SELECTED,
        cId: this.cId,
        tId: this.tId,
        data: {
          licenseDetails: {
            id,
          },
          oI: this.oI,
          offerName: this.offer ? this.offer.name : '',
          cId: this.cId,
          tId: this.offer.id,
        },
      };
      window.parent.postMessage(msg, document.referrer);
    },
    closeIframe() {
      const msg = {
        name: process.env.VUE_APP_IFRAME_MESSAGE_CLOSE_IFRAME,
        cId: this.cId,
        tId: this.tId,
        data: {
          clId: this.clientToken,
          cId: this.cId,
          tId: this.tId,
          paps: JSON.stringify(this.offer ? this.offer.paps : []),
          oI: this.oI,
          offerName: this.offer ? this.offer.name : '',
          // eslint-disable-next-line no-nested-ternary
          type: this.offer ? (this.offer.type === 1 ? 'modal' : 'inline') : null,
        },
      };
      const off = document.getElementById('offer');
      off.classList.add('animated-reverse');
      window.parent.postMessage(msg, document.referrer);
    },
    closeIframeError() {
      const msg = {
        name: process.env.VUE_APP_IFRAME_MESSAGE_CLOSE_IFRAME_ERROR,
        cId: this.cId,
        tId: this.tId,
        data: {
          clId: this.clientToken,
          cId: this.cId,
          paps: [],
          oI: this.oI,
          offerName: this.offer ? this.offer.name : '',
          // eslint-disable-next-line no-nested-ternary
          type: this.offer ? (this.offer.type === 1 ? 'modal' : 'inline') : null,
        },
      };
      window.parent.postMessage(msg, document.referrer);
    },
    resizeIframe() {
      if (this.offer.type === configs.OFFER_TYPE.INLINE) {
        const offerCardDiv = document.getElementById(this.offer.template.elementId);
        if (offerCardDiv) {
          const msg = {
            name: process.env.VUE_APP_IFRAME_MESSAGE_RESIZE_IFRAME,
            cId: this.cId,
            tId: this.tId,
            data: {
              width: offerCardDiv.offsetWidth,
              height: offerCardDiv.offsetHeight,
            },
          };
          if (offerCardDiv.offsetHeight > 0) {
            clearInterval(this.offerHeightInterval);
          }
          window.parent.postMessage(msg, document.referrer);
        }
      } else {
        clearInterval(this.offerHeightInterval);
      }
    },
    offerLoaded() {
      const msg = {
        name: process.env.VUE_APP_IFRAME_MESSAGE_OFFER_LOADED,
        cId: this.cId,
        tId: this.tId,
        data: {
          clId: this.clientToken,
          tId: this.tId,
          cId: this.cId,
          paps: JSON.stringify(this.offer ? this.offer.paps : []),
          licenses: JSON.stringify(this.offer ? this.offer.licenses : []),
          oI: this.oI,
          offerName: this.offer ? this.offer.name : '',
          // eslint-disable-next-line no-nested-ternary
          type: this.offer ? (this.offer.type === 1 ? 'modal' : 'inline') : null,
        },
      };
      window.parent.postMessage(msg, document.referrer);
    },
    open() {
      this.showOffer = true;
    },
    closeCheckout() {
      this.showOffer = false;
    },
  },
};
</script>
<style scoped>
.loading-spinner {
  color: #1d79f2 !important;
}
.logging-in {
  font-size: 15px;
  color: #4d4d4d;
  margin-left: 5px;
  margin-bottom: 10px;
  font-weight: 600;
}

.fade-enter-active,
.fade-leave-active {
  transition: all 1s ease-in;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  visibility: hidden;
}
</style>
<style lang="scss">
// eslint-disable-next-line max-len
</style>
<style lang="scss">
.tonos-app,
html,
body,
#offer,
#l-form-response,
.offer {
  width: 100%;
  min-height: 100% !important;
  /* display: flex; */
  /* justify-content: center; */
  /* align-items: center; */
}
html,
body,
.tonos-app {
  background-color: transparent !important;
  min-height: 100% !important;
  width: 100%;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
::-webkit-scrollbar {
  display: none;
}


</style>
